module.exports = __webpack_public_path__ + "img/viewer_profile_gallery_daugther.79de45ab.png";